var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSentEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9869 16.561C13.4927 25.68 -0.00140978 33.1686 1.1047e-07 33.2024C0.00411228 33.3004 18.9922 40.1658 19.1287 40.1185C19.2263 40.0847 35.4238 25.2021 46.5687 14.9057C47.6685 13.8897 48.5212 13.1363 48.4634 13.2316C48.4056 13.3268 43.3719 20.0174 37.2773 28.0994L26.1963 42.7941L26.2264 50.897L26.2566 59L31.5312 52.944C34.4322 49.6132 36.8424 46.8472 36.8872 46.7972C36.932 46.7472 40.0306 47.8211 43.7729 49.1836L50.5771 51.6608L50.6689 51.3526C50.7742 50.9992 60.0356 0.0291069 59.9999 1.10961e-05C59.987 -0.0104957 46.4812 7.44196 29.9869 16.561Z",
    fill: "#2653F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentEmailIcon);
export default __webpack_public_path__ + "static/media/sentEmailIcon.4a09a67fc8f7fd43a59f40b196cc9549.svg";
export { ForwardRef as ReactComponent };